import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { useStore } from 'react-redux'

import { getEstimate } from './getEstimate'
import { normalizeEstimateData } from './helper/normalizeEstimateData'

// Read from the store at export time instead of subscribing: the hook lives in
// the always-mounted project menu, and the estimate tree is expensive (OCT-5072).
export const useEstimatePayload = () => {
  const store = useStore<AppState>()

  return () => {
    const state = store.getState()

    const lineItems =
      migrationProjectSelector.getProjectEstimateLineItemsWithNodeValue(state)

    const linkedLineItems =
      migrationProjectSelector.getProjectEstimateLinkedLineItems(state)

    const estimateData = getEstimate(state, linkedLineItems)

    return {
      settings: {
        currency: migrationProjectSelector.getProjectEstimateCurrency(state),
        estimateUnits: migrationProjectSelector.getProjectEstimateUnits(state),
        vat: migrationProjectSelector.getProjectEstimateVat(state),
        taxEnabled:
          migrationProjectSelector.getProjectEstimateTaxEnabled(state),
      },
      content: normalizeEstimateData(estimateData),
      lineItems,
    }
  }
}
